import { jsx as t, jsxs as g } from "react/jsx-runtime";
import { cloneElement as c } from "react";
import { useMultiStyleConfig as E, Flex as N, Box as u, Divider as w } from "@chakra-ui/react";
import { FormControl as C } from "../FormControl/FormControl.mjs";
const F = ({
  controlClassName: s,
  controlStyleProps: v,
  error: r,
  input: e,
  isDisabled: m,
  isReadOnly: n,
  isRequired: o,
  leftInputWidth: x,
  select: f,
  selectPosition: l = "left",
  size: i = "md",
  ...h
}) => {
  const a = E("DualInput"), d = l === "left" ? f : e, p = l === "left" ? e : f;
  return /* @__PURE__ */ t(
    C,
    {
      className: s,
      error: r,
      isRequired: o,
      ...v,
      ...h,
      children: /* @__PURE__ */ g(N, { direction: "row", wrap: "nowrap", children: [
        /* @__PURE__ */ t(
          u,
          {
            __css: a.leftElement,
            width: x,
            flex: l === "left" ? void 0 : 1,
            maxW: l === "left" ? "50%" : void 0,
            children: c(d, {
              className: "dual-input-left",
              controlClassName: "dual-input-left-control",
              isInvalid: r,
              isDisabled: m,
              isReadOnly: n,
              isRequired: o,
              size: i
            })
          }
        ),
        (n || d.props.variant === "filled" && p.props.variant === "filled") && /* @__PURE__ */ t(w, { orientation: "vertical", sx: a.divider }),
        /* @__PURE__ */ t(
          u,
          {
            __css: a.rightElement,
            flex: l === "left" ? 1 : void 0,
            maxW: l === "left" ? void 0 : "50%",
            children: c(p, {
              className: "dual-input-right",
              controlClassName: "dual-input-right-control",
              isInvalid: r,
              isDisabled: m,
              isReadOnly: n,
              isRequired: o,
              size: i
            })
          }
        )
      ] })
    }
  );
};
export {
  F as DualInput
};
